import factory from "tiny-relative-date/lib/factory";
import * as fns from "duration-fns";
import { formatTime } from "@std/lib/mathsExtension.js";
import { playlistIds, trdLocale, blurImageURL } from "@std/lib/publicEnv.js";
import Tilt from "react-parallax-tilt";

import { useState } from "react";

import Image from "next/image";
import { FaCrown, FaPencilAlt, FaStar } from "react-icons/fa";

export default function Thumbnail(props) {
  let videoType = "Kooleyy";
  if (props.playlistId === playlistIds.teamVideos) {
    videoType = "Team";
  }
  if (props.playlistId === playlistIds.bestVideos) {
    videoType = "Best";
  }

  let modTranslate = trdLocale;
  modTranslate.overAYearAgo = `${
    new Date().getFullYear() - new Date(props.timestamp).getFullYear()
  } years ago`;

  const relativeDate = factory(modTranslate);

  const videoQuals = [
    "maxresdefault",
    "hqdefault",
    "sddefault",
    "mqdefault",
    "default",
  ];

  const [videoSrc, setVideoSrc] = useState(
    `https://i3.ytimg.com/vi_webp/${props?.id}`
  );
  const [videoQual, setVideoQual] = useState(videoQuals[0]);
  const [forceUniformSize, setForceUniformSize] = useState(false);

  const duration = formatTime(fns.toSeconds(props.duration));
  let rd = relativeDate(props.timestamp);

  function GetThumbnail() {
    return (
      <>
        <Image
          src={`${videoSrc}/${videoQual}.webp`}
          placeholder="blur"
          blurDataURL={blurImageURL.video}
          width="1280"
          height="720"
          alt={props.title}
          className={`object-cover ${
            forceUniformSize
              ? "aspect-video 2xl:h-[13.5rem] w-full"
              : "w-full h-full"
          } bg-gray-500 text-gray-500`}
          style={{ backgroundPosition: "center" }}
          unoptimized={props.optimized ? false : true}
          onLoad={(i) => {
            if (
              i?.target?.naturalWidth === 1280 &&
              i?.target?.naturalHeight === 720
            )
              return;
            setForceUniformSize(true);
            const cur = videoQuals.indexOf(videoQual);
            const use = cur !== -1 ? cur : null;

            if (use === null) return setVideoSrc(`/thumbnail.jpg`);
            return setVideoQual(videoQuals[cur + 1] || "default");
          }}
        />
        {props.timestamp ? (
          <span className="absolute w-fit mx-2 my-2 py-1 px-1 bottom-0 left-0 bg-gray-800 text-white text-xs text-center leading-4 rounded-[0.5rem] z-20">
            {rd}
          </span>
        ) : null}
        {forceUniformSize ? (
          <span className="absolute w-fit mx-2 my-2 py-1 px-1 top-0 right-0 bg-red-950 text-white text-xs text-center leading-4 rounded-[0.5rem] z-20">
            HD unavailable
          </span>
        ) : null}
        <div className="hidden disable:block top-0 -inset-full h-full w-1/2 z-5 transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-40 group-hover:animate-shine" />
      </>
    );
  }

  return (
    <div className="flex flex-col gap-y-3 h-full">
      <a
        href={props.href}
        rel="noreferrer"
        target="_blank"
        className="rounded-2xl"
      >
        <Tilt
          tiltEnable={false}
          glareEnable={false}
          glareMaxOpacity={0}
          glarePosition={"all"}
          perspective={2000}
          scale={1.05}
          className="hidden md:block group relative w-full bg-black transition-all ease-in-out duration-200 rounded-2xl overflow-hidden"
        >
          <GetThumbnail />
        </Tilt>
        <Tilt
          tiltEnable={false}
          glareEnable={false}
          glareMaxOpacity={0}
          glarePosition={"all"}
          perspective={2000}
          scale={1.05}
          className="md:hidden group relative w-full bg-black transition-all ease-in-out duration-200 rounded-2xl overflow-hidden"
        >
          <GetThumbnail />
        </Tilt>
      </a>
      <div
        className={`flex flex-col h-full w-full ${
          forceUniformSize && "justify-s"
        }`}
      >
        <div>
          <a href={props.authorHref} target="_blank" rel="noreferrer noopener">
            <Image
              height="64"
              width="64"
              referrerPolicy="no-referrer"
              className="rounded-xl w-12 sm:w-8 md:w-9 lg:w-10 xl:w-11 2xl:w-12 float-left mr-2"
              alt={props.author}
              src={props.authorPhoto}
            />
          </a>
          <div className="flex flex-col gap-y-2">
            <div className="flex flex-row gap-x-2 items-start">
              <span className="font-BreezeAltHeader font-medium text-sm flex flex-col">
                <a
                  href={props.href}
                  rel="noreferrer"
                  target="_blank"
                  className={`font-BreezeAltHeader font-bold hover:text-gray-300 transition-all ease-in-out duration-200`}
                >
                  {props.title}
                </a>
                <div className="flex flex-row gap-x-1 font-semibold">
                  <a
                    href={props.authorHref}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {" "}
                    {props.authorId === "UCxlyTwuE1uuieLnl_tjBYVQ" ? (
                      <span className="flex gap-x-1 items-center">
                        Kooleyy <FaCrown className="text-yellow-400 w-5" />
                      </span>
                    ) : (
                      props.author
                    )}
                  </a>
                  {props.views
                    ? ` · ${Intl.NumberFormat("en-US", {
                        notation: "compact",
                        maximumFractionDigits: 1,
                      }).format(props.views)} views`
                    : null}
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
